import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import { IoMdArrowBack } from "react-icons/io";
import { hrRecordsApi } from "../../Services/hrRecordsApi";
import { formatDateOnlyIST } from "../hrRecordsHelpers";
import "../hrRecords.css";

function TrainingEmployeeHistoryPage({ isSidebarExpanded }) {
  const { employeeId } = useParams();
  const navigate = useNavigate();
  const [history, setHistory] = useState(null);

  useEffect(() => {
    const run = async () => {
      try {
        const response = await hrRecordsApi.getEmployeeTrainingHistory(employeeId);
        setHistory(response);
      } catch (error) {
        console.error("Failed to load employee training history:", error);
      }
    };
    run();
  }, [employeeId]);

  return (
    <div
      className={`data-list-content-container page-content ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="data-list-content">
        <div className="data-list-header">
          <div className="data-list-header-content">
            <div className="data-list-heading-content-left-side">
              <Tooltip title="Back" arrow>
                <IoMdArrowBack
                  className="back-company"
                  onClick={() => navigate(-1)}
                />
              </Tooltip>
              Employee Training History
            </div>
          </div>
        </div>
        <div className="header-separator"></div>

        <div className="data-list-body">
          {!history ? (
            <div className="loader-container">
              <div className="loader"></div>
              <div>Loading...</div>
            </div>
          ) : (
            <div className="data-list-scroll-body">
              <div className="hr-records-section">
                <div className="hr-records-section-title">
                  {history.employee?.person_name || "Employee"}
                </div>
                <div style={{ color: "#68768a" }}>
                  EC No: {history.employee?.ec_no || "NA"} | Project:{" "}
                  {history.employee?.project_name || "NA"} | Total Trainings:{" "}
                  {history.total_trainings || 0}
                </div>
              </div>

              <div className="data-list-table">
                {history.trainings?.length ? (
                  <table className="table multilevel-data">
                    <thead>
                      <tr>
                        <th>TRAINING</th>
                        <th>SESSION</th>
                        <th>ISSUE DATE</th>
                        <th>EXPIRY DATE</th>
                        <th>NEXT DUE</th>
                        <th>STATUS</th>
                        <th>CERTIFICATE</th>
                      </tr>
                    </thead>
                    <tbody className="data-list-scroll-bodys">
                      {history.trainings.map((training) => (
                        <tr key={training.participant_id} className="hoverable-row">
                          <td>{training.training_name || "NA"}</td>
                          <td>{training.session_code || "NA"}</td>
                          <td>{formatDateOnlyIST(training.issue_date)}</td>
                          <td>{formatDateOnlyIST(training.expiry_date)}</td>
                          <td>{formatDateOnlyIST(training.next_due_date)}</td>
                          <td>{training.status || "NA"}</td>
                          <td>{training.certificate_number || "NA"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="hr-records-empty">No training history found.</div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TrainingEmployeeHistoryPage;
